import React from 'react';
import { LogoIconProps } from './logo';

const TED = ({ width = 93, className, color = 'var(--brand-950)', opacity = 0.5 }: LogoIconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    viewBox='0 0 93 48'
    fill='none'
    className={className}
  >
    <path
      d='M9.33698 15.787H0L0 7.22058H29.0184V15.787H19.6794V40.7792H9.33698V15.787ZM30.6242 7.22058H58.8397V15.787H40.9675V19.9191H58.8397V27.9801H40.9675V32.2128H58.8397V40.7792H30.6242V7.22058ZM60.5455 7.22058H77.5148C88.661 7.22058 92.5754 15.4847 92.5754 23.9502C92.5754 34.2292 87.1524 40.7792 75.5061 40.7792H60.5455V7.22058ZM70.8888 32.2128H74.9032C81.3292 32.2128 82.235 26.9734 82.235 23.8496C82.235 21.7324 81.5321 15.8878 74.1003 15.8878H70.7859L70.8888 32.2128Z'
      fill='white'
    />
    <path
      d='M9.33698 15.787H0L0 7.22058H29.0184V15.787H19.6794V40.7792H9.33698V15.787ZM30.6242 7.22058H58.8397V15.787H40.9675V19.9191H58.8397V27.9801H40.9675V32.2128H58.8397V40.7792H30.6242V7.22058ZM60.5455 7.22058H77.5148C88.661 7.22058 92.5754 15.4847 92.5754 23.9502C92.5754 34.2292 87.1524 40.7792 75.5061 40.7792H60.5455V7.22058ZM70.8888 32.2128H74.9032C81.3292 32.2128 82.235 26.9734 82.235 23.8496C82.235 21.7324 81.5321 15.8878 74.1003 15.8878H70.7859L70.8888 32.2128Z'
      fill={color}
      fillOpacity={opacity}
    />
  </svg>
);

export default TED;
